import { render } from "./OrderCart.vue?vue&type=template&id=a91bd954&scoped=true"
import script from "./OrderCart.vue?vue&type=script&lang=js"
export * from "./OrderCart.vue?vue&type=script&lang=js"

import "./OrderCart.vue?vue&type=style&index=0&id=a91bd954&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/changlei/roblox-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a91bd954"]])

export default __exports__